const state = {
  buttonGroupActive: null,
  filters: [],
  daterange: null
}

const getters = {}

const mutations = {
  setButtonGroupActive (state, buttonGroupActive) {
    state.buttonGroupActive = buttonGroupActive
  },
  setFilters (state, filters) {
    state.filters = filters
  },
  changeButtonGroupActive (state, selectedButtonGroupActive) {
    state.buttonGroupActive = selectedButtonGroupActive
    state.filters.map((filter) => {
      if (filter.value === selectedButtonGroupActive.value) {
        // eslint-disable-next-line no-return-assign
        return filter.active = true
      } else {
        // eslint-disable-next-line no-return-assign
        return filter.active = false
      }
    })
  },
  setDateRange (state, daterange) {
    state.daterange = daterange
  }
}

const actions = {
  setButtonGroupActive ({ commit, state }, buttonGroupActive) {
    commit('setButtonGroupActive', buttonGroupActive)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
